var _path, _path2, _path3, _line, _line2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path4, _line3, _path5, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackwash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.4727 73.9248V73.9258C61.0181 74.6707 61.5277 75.4267 62.0459 76.2148C64.5053 79.9553 66.754 83.8777 67.749 88.123C67.7675 88.2021 67.7819 88.2946 67.7998 88.4238C67.8158 88.5392 67.837 88.704 67.8662 88.8613C68.3494 91.4643 67.5031 94.297 65.7041 96.2412L65.7012 96.2441C64.0901 97.9984 61.9387 98.9457 59.5244 98.999C57.5608 98.984 55.5882 98.2907 54.1074 97.0273C52.6367 95.7724 51.6019 94.1092 51.1973 92.2334C51.121 91.8798 51.0647 91.5687 51.04 91.2598C50.9838 90.5551 50.9829 89.8539 51.0654 89.1855C51.346 86.9135 52.3543 84.291 53.6797 81.6982C54.9979 79.1196 56.5936 76.638 57.9873 74.6621C58.4951 73.9423 58.9777 73.2425 59.4785 72.5771L60.4727 73.9248Z",
    stroke: "#128370",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4727 23.9248V23.9258C47.0181 24.6707 47.5277 25.4267 48.0459 26.2148C50.5053 29.9553 52.754 33.8777 53.749 38.123C53.7675 38.2021 53.7819 38.2946 53.7998 38.4238C53.8158 38.5392 53.837 38.704 53.8662 38.8613C54.3494 41.4643 53.5031 44.297 51.7041 46.2412L51.7012 46.2441C50.0901 47.9984 47.9387 48.9457 45.5244 48.999C43.5608 48.984 41.5882 48.2907 40.1074 47.0273C38.6367 45.7724 37.6019 44.1092 37.1973 42.2334C37.121 41.8798 37.0647 41.5687 37.04 41.2598C36.9838 40.5551 36.9829 39.8539 37.0654 39.1855C37.346 36.9135 38.3543 34.291 39.6797 31.6982C40.9979 29.1196 42.5936 26.638 43.9873 24.6621C44.4951 23.9423 44.9777 23.2425 45.4785 22.5771L46.4727 23.9248Z",
    stroke: "#128370",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4727 23.9248V23.9258C75.0181 24.6707 75.5277 25.4267 76.0459 26.2148C78.5053 29.9553 80.754 33.8777 81.749 38.123C81.7675 38.2021 81.7819 38.2946 81.7998 38.4238C81.8158 38.5392 81.837 38.704 81.8662 38.8613C82.3494 41.4643 81.5031 44.297 79.7041 46.2412L79.7012 46.2441C78.0901 47.9984 75.9387 48.9457 73.5244 48.999C71.5608 48.984 69.5882 48.2907 68.1074 47.0273C66.6367 45.7724 65.6019 44.1092 65.1973 42.2334C65.121 41.8798 65.0647 41.5687 65.04 41.2598C64.9838 40.5551 64.9829 39.8539 65.0654 39.1855C65.346 36.9135 66.3543 34.291 67.6797 31.6982C68.9979 29.1196 70.5936 26.638 71.9873 24.6621C72.4951 23.9423 72.9777 23.2425 73.4785 22.5771L74.4727 23.9248Z",
    stroke: "#128370",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 54,
    x2: 94,
    y2: 54,
    stroke: "#128370",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 65,
    x2: 94,
    y2: 65,
    stroke: "#128370",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 59,
    width: 2,
    height: 2,
    fill: "#128370"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 41,
    width: 2,
    height: 2,
    fill: "#128370"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 41,
    width: 2,
    height: 2,
    fill: "#128370"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 37,
    width: 2,
    height: 2,
    fill: "#128370"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 37,
    width: 2,
    height: 2,
    fill: "#128370"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 42,
    width: 2,
    height: 2,
    fill: "#128370"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 42,
    width: 2,
    height: 2,
    fill: "#128370"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2998,
    y: 59,
    width: 2,
    height: 2,
    fill: "#128370"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5996,
    y: 59,
    width: 2,
    height: 2,
    fill: "#128370"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 47.8994,
    y: 59,
    width: 2,
    height: 2,
    fill: "#128370"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1992,
    y: 59,
    width: 2,
    height: 2,
    fill: "#128370"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 62.499,
    y: 59,
    width: 2,
    height: 2,
    fill: "#128370"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 69.7988,
    y: 59,
    width: 2,
    height: 2,
    fill: "#128370"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 77.0986,
    y: 59,
    width: 2,
    height: 2,
    fill: "#128370"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 84.3984,
    y: 59,
    width: 2,
    height: 2,
    fill: "#128370"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 91.6982,
    y: 59,
    width: 2,
    height: 2,
    fill: "#128370"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 81.5L36 74.5L43 81.5",
    stroke: "#128370",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 21,
    y2: -1,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 35 95)",
    stroke: "#128370",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77 81.5L84 74.5L91 81.5",
    stroke: "#128370",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 21,
    y2: -1,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 83 95)",
    stroke: "#128370",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackwash);
export default __webpack_public_path__ + "static/media/Backwash.54199c0554b8b74b3e17833ef9309e59.svg";
export { ForwardRef as ReactComponent };